module.exports = __webpack_public_path__ + "media/luxury-2026/mianus-garden-living-960-96466342.jpg";